const debounce = require('lodash.debounce');
const requireNotEmpty = require('../common/validate-textfield');
const requireChecked = require('../common/validate-checkables-atleastone');

let currentEngravableCharLimit = 0;
let engravableProductCost = 0;
let numCharsPerLine = 0;

let cursorPosition = {
	name: 'engravableProductText0',
	position: 0
};

const init = () => {
	window.jQuery('#engravableProductText').on('keyup input', updateTextCharsLeftDebounced).change();

	window.jQuery('#membershipproductform').on('submit', validate);

	window.jQuery('#engravableProductRate').on('change', showEngravableFields).change();

	// This is a safety if the config fails to load.  just emit change
	window.jQuery('#reloadProductConfig').on('click', (e) => {
		e.preventDefault();
		window.jQuery('#engravableProductRate').change();
	});

	window.jQuery('#openGreekChars').on('click', openGreekChars);
	window.jQuery('.greekChar').on('click', insertGreekChar);
};

const hideProductLoading = () => {
	window.jQuery('#productLoading').addClass('hide');
};

const insertGreekChar = (e) => {
	let char = window.jQuery(e.target).data('character');
	let val = window.jQuery('#' + cursorPosition.name).val();

	val = val.substring(0, cursorPosition.position) + char + val.substring(cursorPosition.position, val.length);
	val = val.substring(0, numCharsPerLine).toUpperCase();

	cursorPosition.position++;

	window.jQuery('#' + cursorPosition.name).val(val);

	window.jQuery('#greekCharModal').modal('hide');
};

const openGreekChars = (e) => {
	e.preventDefault();
	window.jQuery('#greekCharModal').modal('show');
};

const showEngravableFields = (e) => {
	window.jQuery('#productLoadError,#engravableProductConfig').addClass('hide');
	window.jQuery('#submitReg').attr('disabled', false);

	let $this = window.jQuery(e.target);

	let $engravableProductConfig = window.jQuery('#engravableProductConfig');

	if ($this.val() === '') {
		$engravableProductConfig.addClass('hide');
		return;
	}
	window.jQuery
		.ajax({
			url: '/index.cfm/membership:home/engravableProductConfig',
			data: {
				rate: $this.val()
			},
			cache: false,
			beforeSend: () => {
				showProductLoading();
				window.jQuery('#continueProducts').prop('disabled', true);
			}
		})
		.then((result) => {
			currentEngravableCharLimit = result.numCharsAvailable || 0;
			engravableProductCost = new Number(result.rateDollars).valueOf();

			if (result.measurementUnit !== '') {
				let size = '';
				if (result.width !== '') {
					size += result.width.toString() + result.measurementUnit + ' wide';
				}
				if (size !== '') {
					size += ' x ';
				}
				if (result.height !== '') {
					size += result.height.toString() + result.measurementUnit + ' height';
				}
				if (size !== '') {
					size += ' x ';
				}
				if (result.depth !== '') {
					size += result.depth.toString() + result.measurementUnit + ' deep';
				}

				$engravableProductConfig.find('.size small').html(`<b>Size: </b> ${size}`);
			}

			let inputs = '';
			for (let x = 0; x < result.numLinesAvailable; x++) {
				inputs += `<input type="text" id="engravableProductText${x}" maxlength="${result.numCharsPerLine}" name="engravableProductText${x}" class="form-control lineInput" value="" style="letter-spacing: .5em; text-align:center; font-weight:bold;" />`;
			}

			window.jQuery('.lineInput').remove();
			window.jQuery('#openGreekChars').before(inputs);

			window.jQuery('.lineInput').on('focus keyup click', recordCursorPosition);

			numCharsPerLine = result.numCharsPerLine;

			$engravableProductConfig.find('.description').html(result.description);
			$engravableProductConfig.removeClass('hide');
		})
		.fail((err) => {
			window.jQuery('#productLoadError').removeClass('hide');
			window.jQuery('#submitReg').attr('disabled', true);
		})
		.always(() => {
			hideProductLoading();
			window.jQuery('#continueProducts').prop('disabled', false);
		});
};

const showProductLoading = () => {
	window.jQuery('#productLoading').removeClass('hide');
};

const recordCursorPosition = (e) => {
	cursorPosition = {
		name: e.target.name,
		position: e.target.selectionStart
	};
	window.jQuery(e.target).val(window.jQuery(e.target).val().toUpperCase());
	console.log(cursorPosition);
};

const updateTextCharsLeft = (e) => {
	let $this = window.jQuery(e.target);

	$this.val($this.val().substr(0, currentEngravableCharLimit));

	let charsUsed = $this.val().toString().length;

	let charsLeft = currentEngravableCharLimit - charsUsed;

	$this.siblings('.help-block').html(`Chars Left: ${charsLeft}`);
};
const updateTextCharsLeftDebounced = debounce(updateTextCharsLeft, 100);

const validate = () => {
	let error = false;

	if (window.jQuery('#engravableProductRate').val() !== '') {
		error = requireNotEmpty('.isRequired', '.errorContainer', 'has-error has-feedback') || error;

		error = requireChecked('#schoolStamp') || error;

		error = requireChecked('#greekAlphabet') || error;

		// We need to make sure that a browser doesn't bust our max length setting
		// We'll validate each line. If its too long, then highlight it
		// If any line is too long, show the help text
		let aLineHasTooManyChars = false;
		window.jQuery('.lineInput').each((i) => {
			let $el = window.jQuery('.lineInput').eq(i);
			let lineNotValid = $el.val().length > $el.prop('maxlength');
			error = lineNotValid || error;
			if (lineNotValid) {
				$el.closest('.form-group').addClass('has-error');
				aLineHasTooManyChars = true;
			} else {
				$el.closest('.form-group').removeClass('has-error');
			}
		});
		if (aLineHasTooManyChars) {
			window
				.jQuery('#lines-help-text')
				.html(
					`You many only have a maximum of ${window.jQuery('.lineInput').eq(0).prop('maxlength')} characters per line`
				);
		} else {
			window.jQuery('#lines-help-text').empty();
		}
	}

	return !error;
};

module.exports = {
	init,
	validate
};
